import { render, staticRenderFns } from "./noInform.vue?vue&type=template&id=6a45dcca&scoped=true"
import script from "./noInform.vue?vue&type=script&lang=js"
export * from "./noInform.vue?vue&type=script&lang=js"
import style0 from "./noInform.vue?vue&type=style&index=0&id=6a45dcca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a45dcca",
  null
  
)

export default component.exports